export default __webpack_public_path__ + "static/media/about_block.510c8bef.png";